<template>
  <div id="hygrrh">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'hygrrh'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/member/membership/person/Hygrrh.vue